class CameraComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { CameraComponentData };
